import { pubSub } from './pubSub-sidecar'
import { storer } from '../lib/storer-sidecar'
import chroma from 'chroma-js'

interface IHSL {
  h: number
  s: number
  l: number
}

export interface ISettings {
  devMode: boolean
  freeBuildMode: boolean
  muteSound: boolean
  muteMusic: boolean
  skipStart: boolean
  // Extended
  filename: string
  testRigNum: number
  shipHullColor: IHSL
  shipInternalColor: IHSL
}

let settings: ISettings = {
  devMode: false,
  freeBuildMode: false,
  muteSound: false,
  muteMusic: false,
  skipStart: true,
  filename: 'test',
  testRigNum: 0,
  shipHullColor: { h: 100, s: 50, l: 50 },
  shipInternalColor: { h: 100, s: 10, l: 90 },
}

let _localStorageKey = ''
let _version = 0
export function create(localStorageKey: string, version: number) {
  _localStorageKey = localStorageKey
  _version = version
  load()
}

export function get() {
  return settings
}
export function update(updates: Partial<ISettings>, doSave = true) {
  settings = Object.assign({}, settings, updates)
  if (doSave) {
    save()
  }
  pubSub.emit('settings:update')
}
export function updateShipHullColor(updates: Partial<IHSL>, doSave = true) {
  let newColor = Object.assign({}, settings.shipHullColor, updates)
  update({ shipHullColor: newColor }, doSave)
}
export function updateShipInternalColor(updates: Partial<IHSL>, doSave = true) {
  let newColor = Object.assign({}, settings.shipInternalColor, updates)
  update({ shipInternalColor: newColor }, doSave)
}
function load() {
  let data = storer.load(_localStorageKey, _version)
  if (data) {
    update(data, false)
  }
  console.log('loaded settings', data)
}

function save() {
  storer.save(_localStorageKey, _version, get())
}

export function getShipHullColorTint() {
  let c = chroma(
    settings.shipHullColor.h,
    settings.shipHullColor.s / 100,
    settings.shipHullColor.l / 100,
    'hsl',
  )
  return c.num()
}
export function getShipInternalColorTint() {
  let c = chroma(
    settings.shipInternalColor.h,
    settings.shipInternalColor.s / 100,
    settings.shipInternalColor.l / 100,
    'hsl',
  )
  return c.num()
}
